<template>
  <van-popup
    v-model="visible"
    :style="{ 
      width: '70%', 
      maxWidth: '270px',
      borderRadius: '8px',
      padding: '20px 16px',
      background: '#ffffff'
    }"
    :overlay="true"
    :close-on-click-overlay="closeOnClickOverlay"
    @click-overlay="handleOverlayClick"
  >
    <div class="validation-popup">
      <!-- 标题 -->
      <div class="popup-title">{{ title }}</div>

      <!-- 校验项列表 -->
      <div class="validation-list">
        <div
          v-for="(item, index) in validationItems"
          :key="index"
          class="validation-item"
        >
          <!-- 状态图标 -->
          <div class="status-icon">
            <van-icon
              v-if="item.status === 'success'"
              name="success"
              class="success-icon"
            />
            <van-icon
              v-else-if="item.status === 'error'"
              name="cross"
              class="error-icon"
            />
            <van-icon
              v-else
              name="minus"
              class="pending-icon"
            />
          </div>
          
          <!-- 文字内容 -->
          <div class="item-text" :class="getTextClass(item.status)">
            {{ item.text }}
          </div>
        </div>
      </div>

      <!-- 确认按钮 -->
      <van-button
        type="primary"
        color="#000000"
        round
        block
        class="confirm-button"
        @click="handleConfirm"
      >
        {{ confirmText }}
      </van-button>

      <!-- 取消按钮 -->
      <van-button
        v-if="showCancelButton"
        type="primary"
        class="cancel-button"
        @click="handleCancel"
      >
        {{ cancelText }}
      </van-button>
    </div>
  </van-popup>
</template>

<script>
import { Popup, Icon, Button } from 'vant'

export default {
  name: 'ValidationResultPopup',
  components: {
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Button.name]: Button,
  },
  props: {
    // 是否显示弹窗
    value: {
      type: Boolean,
      default: false
    },
    // 弹窗标题
    title: {
      type: String,
      required: true
    },
    // 校验项数组
    validationItems: {
      type: Array,
      default: () => [],
      validator: (items) => {
        return items.every(item => 
          typeof item === 'object' && 
          typeof item.text === 'string' && 
          ['success', 'error', 'pending'].includes(item.status)
        )
      }
    },
    // 确认按钮文字
    confirmText: {
      type: String,
      default: '我知道了'
    },
    // 取消按钮文字
    cancelText: {
      type: String,
      default: '取消'
    },
    showCancelButton: {
      type: Boolean,
      default: false
    },
    // 点击遮罩是否关闭
    closeOnClickOverlay: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false
    }
  },
  watch: {
    value: {
      handler(newVal) {
        this.visible = newVal
      },
      immediate: true
    },
    visible(newVal) {
      if (!newVal) {
        this.$emit('input', false)
        this.$emit('close')
      }
    }
  },
  methods: {
    // 获取文字样式类
    getTextClass(status) {
      return {
        'text-success': status === 'success',
        'text-error': status === 'error',
        'text-pending': status === 'pending'
      }
    },
    // 关闭弹窗
    close() {
      this.visible = false
    },
    // 处理确认按钮点击
    handleConfirm() {
      this.$emit('confirm')
      this.close()
    },
    handleCancel() {
      this.$emit('cancel')
      this.close()
    },  
    // 处理遮罩点击
    handleOverlayClick() {
      if (this.closeOnClickOverlay) {
        this.close()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.validation-popup {
  text-align: center;
}

.popup-title {
  font-size: 17px;
  line-height: 24px;
  font-weight: 600;
  color: #1D2129;
  margin-bottom: 16px;
  line-height: 1.4;
}

.validation-list {
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.validation-item {
  display: flex;
  align-items: center;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  color: #00000080;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.status-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
  flex-shrink: 0;
  
  .success-icon {
    color: #06c39b;
    font-size: 16px;
    font-weight: 700;
  }
  
  .error-icon {
    color: #a8a8a8;
    font-size: 16px;
    font-weight: 700;
  }
  
  .pending-icon {
    color: #c8c9cc;
    font-size: 16px;
  }
}

.item-text {
  font-size: 14px;
  line-height: 1.5;
  flex: 1;
  
  &.text-success {
    color: #000000;
  }
  
  &.text-error {
    color: #00000080;
  }
  
  &.text-pending {
    color: #969799;
  }
}

.cancel-button {
  font-size: 16px;
  margin-top: 8px;
  color: #86909C;
  height: 36px;
  background-color: transparent;
  border: none;
}

.confirm-button {
  font-size: 16px;
  height: 36px;
  margin-top: 20px;
}
</style> 